// src/components/InformationPanel
import React from 'react';
import {
    calculateAgePoints,
    calculateCanadianWorkExperiencePoints,
    calculateEducationPoints,
    calculateFirstLanguagePoints,
    calculateSecondLanguagePoints,
    calculateForeignWorkExperiencePoints,
    calculateSpouseLanguagePoints // <-- Add the missing import here
} from '../utils/crsCalculations';
import { Typography, Box } from '@mui/material';
import LanguageTestComponent from '../utils/LanguageInfo';
import LanguageTestSelectionInfo from '../utils/LanguageTestSelectionInfo';
import LanguageScoresInfo from '../utils/LanguageScoresInfo';
import EducationComponent from '../utils/EducationInfo';
import WorkExperienceComponent from '../utils/WorkExperienceInfo';
import AgePointsComponent from '../utils/AgeInfo';
import PNPNominationComponent from '../utils/PNPInfo';
import SiblingOrCommonLawComponent from '../utils/SiblingsInfo';
import MarriageComponent from '../utils/MarriageInfo';
import CertificateOfQualificationInfo from '../utils/CertificateOfQualificationInfo';
import ValidJobOfferInfo from '../utils/ValidJobOfferInfo';
import SpouseEducationInfo from '../utils/SpouseEducationInfo';
import SpouseWorkExperienceInfo from '../utils/SpouseWorkExperienceInfo';

function InformationPanel({ currentField, formData }) {
  const renderInfo = () => {
    if (!currentField) {
        return <Typography>Select a field to see more information.</Typography>; // Initial message
    }

    switch (currentField) {
    case 'age':
        // console.log(formData);
        return (
          <AgePointsComponent formData={formData} calculateAgePoints={calculateAgePoints} />
        );
    case 'maritalStatus':
        // console.log(formData);
        return (
            <MarriageComponent formData={formData} calculateMarriageImpact={calculateAgePoints} />
        );
    case 'educationLevel':
        return (
            <EducationComponent formData={formData} calculateEducationPoints={calculateEducationPoints} />
        );
    // --- Language Related Fields ---
    case 'firstLanguageTest':
    case 'secondLanguageTest':
        return <LanguageTestSelectionInfo />;
    case 'firstLanguageScores.speaking':
    case 'firstLanguageScores.listening':
    case 'firstLanguageScores.reading':
    case 'firstLanguageScores.writing':
        return <LanguageScoresInfo testType={formData.firstLanguageTest} />;
    case 'secondLanguageScores.speaking':
    case 'secondLanguageScores.listening':
    case 'secondLanguageScores.reading':
    case 'secondLanguageScores.writing':
        return <LanguageScoresInfo testType={formData.secondLanguageTest} />;
    case 'spouseLanguageTest':
            return (
                <LanguageTestComponent
                    formData={formData}
                    calculateLanguagePoints={calculateFirstLanguagePoints}
                    calculateSecondLanguagePoints={calculateSecondLanguagePoints}
                    calculateSpouseLanguagePoints={calculateSpouseLanguagePoints}
                />
            );
    // --- End Language Fields ---
    case 'isNominated': // This seems incorrect, should likely be 'pnpNominee' based on CRSScoreForm state
        return (
            // TODO: Verify if calculateCanadianWorkExperiencePoints is the correct function here
            <PNPNominationComponent formData={formData} calculatePNPNominationPoints={calculateCanadianWorkExperiencePoints} />
        );
    // Renaming case to match CRSScoreForm state key
    case 'pnpNominee': // Changed from 'isNominated'
    case 'hasProvincialNomination':
         return (
             // TODO: Verify if calculateCanadianWorkExperiencePoints is the correct function here
            <PNPNominationComponent formData={formData} calculatePNPNominationPoints={calculateCanadianWorkExperiencePoints} />
         );


    case 'foreignWorkExperience': // This case already exists
    case 'canadianWorkExperience':
        return (
            <WorkExperienceComponent  formData={formData} calculateCanadianWorkExperiencePoints={calculateCanadianWorkExperiencePoints} calculateForeignWorkExperiencePoints={calculateForeignWorkExperiencePoints} />
        );
    
    // Renaming case to match CRSScoreForm state key
    case 'siblingInCanada': // Changed from 'hasSibling'
    case 'hasSiblingInCanada':
        return (
             // TODO: Verify if calculateCanadianWorkExperiencePoints is the correct function here
            <SiblingOrCommonLawComponent formData={formData} calculateFamilyConnectionPoints={calculateCanadianWorkExperiencePoints} />
        );
    // Add cases for other fields if needed, e.g., spouseEducation, jobOffer, jobOfferNoc
    case 'spouseOrPartnerIsPR':
    case 'spouseOrPartnerWillAccompany':
        return (
            <MarriageComponent formData={formData} calculateMarriageImpact={calculateAgePoints} />
        );
    case 'studiedInCanada':
    case 'canadianEducationLevel':
        return (
            <EducationComponent formData={formData} calculateEducationPoints={calculateEducationPoints} />
        );
    case 'firstLanguageTestValid':
        return (
            <LanguageTestComponent
                formData={formData}
                calculateLanguagePoints={calculateFirstLanguagePoints}
                calculateSecondLanguagePoints={calculateSecondLanguagePoints}
                calculateSpouseLanguagePoints={calculateSpouseLanguagePoints}
            />
        );
    case 'hasCertificateOfQualification':
        return <CertificateOfQualificationInfo />;
    case 'hasValidJobOffer':
    case 'jobOfferNocTeer':
        return <ValidJobOfferInfo />;
    case 'spouseEducationLevel':
        return <SpouseEducationInfo />;
    case 'spouseCanadianWorkExperience':
        return <SpouseWorkExperienceInfo />;
    default:
        return <Typography>Select a field to see more information.</Typography>;
    }
  };

  return (
    <Box sx={{ position: 'sticky', top: '100px', marginTop: 4 }}>
        {renderInfo()}
    </Box>
  );
}

export {InformationPanel};